<div>
  <div *ngIf="label" class="prototype-multiselect-label-wrap flex items-center justify-between gap-2">
    <label class="inline-flex items-center gap-[2px] text-[13px] font-medium leading-[1.5] tracking-[0] text-gray-700 dark:text-gray-200">
      {{ label }}
      <span *ngIf="required" style="color: #DD413C">*</span>
    </label>
  </div>

  <div class="prototype-multiselect-trigger-wrap">
    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="prototype-multiselect-field w-full"
      [ngClass]="{
        'prototype-multiselect-field--clearable': selectedValues.length && !disabled && !blocked,
        'prototype-multiselect-field--invalid': invalid
      }">
      <mat-select
        multiple
        [value]="selectedValues"
        [placeholder]="selectPlaceholder"
        [disabled]="disabled || blocked"
        panelClass="prototype-select-panel search-multiselect-panel"
        (openedChange)="onSelectOpenedChange($event)"
        (selectionChange)="onSelectionChange($event)">

        <mat-select-trigger>
          <span *ngIf="!selectedValues.length" class="text-[13px] leading-[20px] text-gray-500 dark:text-gray-400">
            {{ selectPlaceholder }}
          </span>
          <span *ngIf="selectedValues.length" class="text-[13px] leading-[20px] text-gray-900 dark:text-gray-100">
            {{ triggerLabel }}
          </span>
        </mat-select-trigger>

        <mat-option class="multiselect-search-option" disabled [value]="undefined">
          <input #searchInput
            [(ngModel)]="searchTerm"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="disabled || blocked"
            [placeholder]="searchPlaceholder"
            class="multiselect-search-input"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            autocomplete="off">
        </mat-option>

        <mat-option *ngIf="filteredOptions.length" [value]="selectAllValue">
          {{ allFilteredSelected ? clearFilteredLabel : selectAllLabel }}
        </mat-option>

        <mat-option *ngIf="loading" disabled>
          {{ loadingMessage }}
        </mat-option>

        <mat-option *ngIf="!loading && !filteredOptions.length" disabled>
          {{ emptyMessage }}
        </mat-option>

        <mat-option *ngFor="let option of filteredOptions; trackBy: trackById" [value]="option.id" [disabled]="option.disabled">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Botão limpar tudo (X ao lado da seta) -->
    <button
      *ngIf="selectedValues.length && !disabled && !blocked"
      type="button"
      class="prototype-multiselect-clear"
      title="Limpar seleção"
      aria-label="Limpar seleção"
      (mousedown)="stopMouseDown($event)"
      (click)="clearSelectionFromTrigger($event)">
      <lucide-icon [img]="removeIcon" class="h-3.5 w-3.5"></lucide-icon>
    </button>
  </div>

  <div
    *ngIf="blocked && blockedMessage"
    class="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-[0.74rem] text-amber-800 dark:border-amber-800 dark:bg-amber-950/20 dark:text-amber-300">
    {{ blockedMessage }}
  </div>
</div>